import { createAction, props } from '@ngrx/store';
import { AuditEvent } from '../../data/notifications/notifications.model';

export enum NotificationsActions {
  SetNotifications = '[Notifications] Set',
  UpdateNotifications = '[Notifications] Update',
  MarkAsReadNotification = '[Notifications] Mark As Read',
}

export const SetNotifications = createAction(
  NotificationsActions.SetNotifications,
  props<{
    notifications: {
      list: AuditEvent[];
      type: string;
    };
  }>(),
);

export const UpdateNotifications = createAction(
  NotificationsActions.UpdateNotifications,
  props<{ notification: AuditEvent }>(),
);

export const MarkAsReadNotification = createAction(
  NotificationsActions.MarkAsReadNotification,
  props<{ isMarkAsRead: boolean }>(),
);
